module.exports = __webpack_public_path__ + "c045564866e81c41a1133780c0c12e4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/records2.png
// module id = 708
// module chunks = 0